import { axiosApi } from "shared/api/axios";

export interface ApiResponse {
    status: number;
    data?: any;
    error?: string;
}

export const apiServices = async (values: object): Promise<ApiResponse> => {
    try {
        const response = await axiosApi.post(`${process.env.API_BACKEND}/v1/counterparties/counterparty/`, values);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error: any) {
        return {
            status: error.response?.status || 500,
            error: error.message,
        };
    }
};